import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { iif, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { PunchService } from '@app/services/punch.service';

import {
  loadPunchById,
  loadPunchByIdFailed,
  loadPunchByIdFinished,
  loadPunchesByTurnoverId,
  loadPunchesByTurnoverIdFailed,
  loadPunchesByTurnoverIdFinished,
  sendPunch,
  sendPunchFailed,
  sendPunchFinished,
} from '../actions/punch.actions';

@Injectable()
export class PunchEffects {
  loadPunchById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPunchById),
      mergeMap(action => {
        return this.punchService.loadPunchById(action.punchId).pipe(
          map(punch => loadPunchByIdFinished({ punch })),
          catchError(error => of(loadPunchByIdFailed()))
        );
      })
    )
  );

  sendPunch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sendPunch),
      mergeMap(action => {
        return iif(
          () => !!action.punch.id,
          this.punchService.updatePunch(action.punch),
          this.punchService.createPunch(action.punch)
        ).pipe(
          map(punch => sendPunchFinished({ punch })),
          catchError(error => of(sendPunchFailed()))
        );
      })
    )
  );

  loadPunchesByTurnoverId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPunchesByTurnoverId),
      mergeMap(action => {
        return this.punchService.loadPunchesByTurnoverId(action.turnoverId as any).pipe(
          map(result => loadPunchesByTurnoverIdFinished({ result })),
          catchError(error => of(loadPunchesByTurnoverIdFailed()))
        );
      })
    )
  );

  constructor(private actions$: Actions, private punchService: PunchService) {}
}
